import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import IconButton from '../IconButton/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import AppDrawer from '../app-drawer/AppDrawerContainer'

import messages from './HamburgerMenu.messages'

import { styled } from '@mui/material/styles'

export interface IOwnProps {
    className?: string
}

export type IProps = IOwnProps

const HamburgerMenuButton = styled(IconButton)(({ theme }) => ({
    marginRight: theme.spacing(2),
}))

const HamburgerMenu: React.FC<IProps> = (props) => {
    const { className } = props
    const [drawerOpen, setDrawerOpen] = useState(false)

    const intl = useIntl()

    const handleMenuClick = () => {
        setDrawerOpen(true)
    }

    const handleDrawerClose = () => {
        setDrawerOpen(false)
    }

    return (
        <>
            <div className={className}>
                <HamburgerMenuButton
                    onClick={handleMenuClick}
                    icon={<MenuIcon />}
                    ariaLabel={intl.formatMessage({ ...messages.ariaLabel })}
                />
                <FormattedMessage {...messages.title} />
            </div>
            <AppDrawer
                open={drawerOpen}
                onClose={handleDrawerClose}
            />
        </>
    )
}

export default styled(HamburgerMenu)({
    fontSize: '15px',
    fontWeight: 600,
})
